export const applicationStatuses = [
  'draft',
  'submitted',
  'under_review',
  'rejected',
  'withdrawn',
  'accepted',
  'deleted',
] as const

export const applicationStatusLabels: Record<ApplicationStatus, string> = {
  draft: 'Draft',
  submitted: 'Pending',
  under_review: 'Under review',
  rejected: 'Rejected',
  withdrawn: 'Withdrawn',
  accepted: 'Accepted',
  deleted: 'Deleted',
}

export const applicationStatusColors: Record<
  ApplicationStatus,
  { text: string; bg: string }
> = {
  draft: { text: '', bg: '' },
  submitted: { text: '', bg: '' },
  under_review: { text: 'text-yellow-500', bg: 'bg-yellow-500/10' },
  rejected: { text: 'text-destructive', bg: 'bg-destructive/10' },
  withdrawn: { text: 'text-muted-foreground', bg: 'bg-muted-foreground/10' },
  accepted: { text: 'text-primary', bg: 'bg-primary/10' },
  deleted: { text: 'text-destructive', bg: 'bg-destructive/10' },
}

type ApplicationStatus = typeof applicationStatuses[number]
export default ApplicationStatus
